import type { FindFn } from "@shared/models/analytics/base"
import { createBlankEvent } from "@shared/models/analytics/base"
import type { GroupEditBasic } from "@shared/models/analytics/group"
import Patch from "@shared/models/patch-updater"
import type { PreparedAction } from "@shared/actions/action-doc-builder"
import { partial } from "lodash-es"
import type { Narrative } from "@shared/actions/create-narrative"

interface Payload {
  groupId: string
  value: string
  originalValue: string
}

export default function groupChangeTitleAction(payload: Payload): PreparedAction {
  return {
    name: "GROUP_CHANGE_TITLE",
    payload: payload,
    patches: patches(payload),
    undoPatches: undoPatches(payload),
    narrative: partial(narrative, payload),
  }
}

function patches(payload: Payload) {
  let patch = Patch.create("group", payload.groupId).set("attributes.title", payload.value).patch
  return [patch]
}

function undoPatches(payload: Payload) {
  let patch = Patch.create("group", payload.groupId).set(
    "attributes.title",
    payload.originalValue
  ).patch
  return [patch]
}

function narrative(payload: Payload, _findFn: FindFn, _userId: string): Narrative {
  let newEvent: GroupEditBasic = {
    ...createBlankEvent(),
    root_id: payload.groupId,
    root_type: "group",
    date_plan_scheduled_for: null,

    primary_verb: "edit",
    primary_possessive: "owns",

    primary_object_type: "group",
    primary_object_id: payload.groupId,
    primary_object_specifier: "title",
    primary_object_id_and_ancestor_ids: [payload.groupId],

    adverbial_verb: null,

    adverbial_object_type: null,
    adverbial_object_id: null,
    adverbial_object_specifier: null,
    adverbial_object_id_and_ancestor_ids: [payload.groupId],
  }
  return {
    title: "Changed Group Title",
    titleForAnalytics: "Group - Changed Title",
    description: `Changed the title from "${payload.originalValue}" to ${payload.value}`,
    context: {
      groupId: payload.groupId,
    },
    activity: null,
    newAnalyticsEvents: [newEvent],
  }
}
